module.exports = __webpack_public_path__ + "img/52.counter_woman.e2cda51b.svg";